import React from 'react';
import {BootstrapTable, TableHeaderColumn,InsertButton} from 'react-bootstrap-table'; 
import PopUpOther from'./../PopUp/PopUpOther';
import DataConfig from './../_config.json';  
const jobTypes = ['เปิด','ปิด'];

export default class _tabA extends React.Component {
    state ={
        // data1 : "",
        tableData:[],
        countunitStock:"",
        countunitStocktoDB:"",
        rowChk:"", 
        unitStockintable:"",
        unitStockintabletoDB:"",
        colChk:"",
        rowtb:"5"
    }
    
    _spritData(data){
        var str = data.split("_");
        return str;
   }
    // addData = data => {
    //     switch (data.target.name) {
    //         case "data1": this.setState({data1:data.target.value});break;
    //         default:
    //         break;
    //     }
    // }
    setRow = (count) =>{
        var data = [];
        for(var i = 0 ;i <= count-1 ;i++){
            data[i] = {
                C0 : i+1,
            }
        }
        this.setState({tableData:data});
        console.log(this.state.tableData);
    }
    componentDidMount(){
        this.setRow(this.state.rowtb); 
    }
    componentWillUnmount(){
        console.log('-----------------------------------');
        console.log("exit");
        console.log('-----------------------------------');
    }
    //**************************************************************************popup**************************************************************************************/
    SetPopup=(data)=>{
        this.setState({PopUpTYpe:data});
        this.setState({showPopupOT: !this.state.showPopupOT});   
      //  console.log(data); 
    }
    Get_PopUpOther = (data) =>{
        switch (this.state.PopUpTYpe) {
            case "unitStock": 
               // console.log(data);
                this.setState({countunitStocktoDB :this._spritData(data)[0]}); 
                this.setState({countunitStock :this._spritData(data)[1]});
            break;  
            
            case "unitStockintable": 
            // console.log(data);
             this.setState({unitStockintabletoDB :this._spritData(data)[0]}); 
             this.setState({unitStockintable :this._spritData(data)[1]});
 
            if(this.state.colChk ==="1" && this.state.rowChk ==="1"){
             this.setState({countunitStocktoDB :this._spritData(data)[0]}); 
             this.setState({countunitStock :this._spritData(data)[1]});
            } 

             var dataArray = this.state.tableData;  
             dataArray[this.state.rowChk-1].TypeBtn=1;  

            let arrData = this.state.tableData;
            arrData[this.state.rowChk-1].C1=this._spritData(data)[1];
            arrData[this.state.rowChk-1].TypeBtn=2;
            this.setState({tableData:arrData}); 
         break;  
        }
        this.setState({showPopupOT: !this.state.showPopupOT});
    }
    PopUpOtherClose=(data)=>{
        this.setState({showPopupOT: !this.state.showPopupOT}); 
    }
   _cellButton(cell, row, enumObject, rowIndex) {   
        var btn = this.state.tableData[rowIndex].TypeBtn;   
        var btnShow ="";
            switch (btn) {
                case 1: btnShow =  <i class="fas fa-list" onClick={this.SetPopup.bind(null,"unitStockintable")}></i>; break; 
                default:btnShow = <i class=""></i>; break;
            } 
            return (<div>{btnShow}</div>) ; 
}

onRowClick = (row,col)=>{  
    if(col ===1){   
        this.setState({rowChk:row['C0']}); 
        setTimeout(() => {  
           if(this.state.rowChk ==="1"){ 
             this.setState({colChk:col});
           }    
           var dataArray = this.state.tableData;  
        
           let tableRow=dataArray.length;
           let i;
           for(i=0;i<=tableRow;i++){
               try {
                   dataArray[i].TypeBtn=2;
               } catch (error) {
                   console.log(error); 
               }
           } 
           dataArray[this.state.rowChk-1].TypeBtn=1;   
           this.setState({tableData:dataArray});  
           }, 30);
    }else{
        this.setState({rowChk:row['C0']}); 
        var dataArray = this.state.tableData;
        try {
         dataArray[this.state.rowChk-1].TypeBtn=2;  
        }
        catch(err) {
           console.log(err);   
        }
        this.setState({tableData:dataArray});
    }
} 
_number(cell, row, enumObject, rowIndex) { 
    if (!cell) {
        return "";
   }
//     let data;
//    if(Number.isInteger(cell)){
//         data = cell;
//    }else{
//         data="";
//    }
  
  return cell;
}
onMouseLeave(){
      
     
}
//------------------------------เช็คหลังกรอก-------------------------------------------------------------
afterSaveCell=(row, cellName, cellValue)=> {
    // do your stuff... 
    setTimeout(() => {this.props.Getdata("dataunit",this.state);}, 50);
 
    
    localStorage.setItem("tableunit",JSON.stringify(this.state.tableData)); 
 
    // }
  }
// ... insert row-------------------------------------------
handleInsertButtonClick = (onClick) => {
    // Custom your onClick event here,
    // it's not necessary to implement this function if you have no any process before onClick
    console.log('This is my custom function for InserButton click event');
    onClick();
  }
  createCustomInsertButton = (onClick) => {
    return (
      <InsertButton
        btnText='CustomInsertText'
        btnContextual='btn-warning'
        className='my-custom-class'
        btnGlyphicon='glyphicon-edit'
        onClick={ () => this.handleInsertButtonClick(onClick) }/>
    );
  }
  //...
 
    render() { 
        const cellEditProp = {
            mode: 'click',
            blurToSave: true, 
            afterSaveCell: this.afterSaveCell,
            blurToSave: true,
        }; 
        const options = {
            onRowClick : this.onRowClick ,
            onMouseLeave: this.onMouseLeave,
            insertBtn: this.createCustomInsertButton
        };
        return (
            <div class={this.props.Inventory.showResults  === 1 ? '':"InventoryHidden" }>  
            {this.state.showPopupOT?<PopUpOther closePopup={this.PopUpOtherClose} Get_PopUpOther={this.Get_PopUpOther} type={this.state.PopUpTYpe} Data={this.state.valuePopup} groupdata={this.state.grouptoDB} apikeyData={DataConfig.API_KEY[sessionStorage.getItem("company")]} jwtData={sessionStorage.getItem("Token")}/>:null}
            <br>
            </br>
                <div class="container-fluid">
                <BootstrapTable
                    data={ this.state.tableData }
                    cellEdit={ cellEditProp}   
                    options={ options } 
                    // insertRow 
                >
                    <TableHeaderColumn dataField='C0' isKey width="30" dataAlign="center"> </TableHeaderColumn>
                    <TableHeaderColumn dataField='C1' editable width="40%" dataAlign="center" > หน่วยนับ </TableHeaderColumn>
                    <TableHeaderColumn dataField='Btn' editable={ false } dataAlign="center" width="30" dataFormat={this._cellButton.bind(this)}></TableHeaderColumn>
                    <TableHeaderColumn dataField='C3' editable width="20%" dataAlign="center" dataFormat={this._number.bind(this)} > อัตรา </TableHeaderColumn>
                    <TableHeaderColumn dataField='C4' editable width="10%" dataAlign="center" editable={ { type: 'select', options: { values: jobTypes } } }> การใช้งาน </TableHeaderColumn> 
                </BootstrapTable> 
                <div class="row">
                <br>
                </br>
                <div class="form-group">
                <div class="input-group col-xs-12 col-sm-5 col-md-5 col-lg-2">
                    <span class="input-group-addon"> หน่วยนับสต๊อก : </span>
                    <input id="unitStock" name="unitStock" type="text" class="form-control "  value={this.state.countunitStock}  />
                    <span class="input-group-addon textIcon" onClick={this.SetPopup.bind(null,"unitStock")}> 
                    <i class="fas fa-list"></i> 
                    </span>  
                </div>
                </div>
                </div>
                </div>
            </div>
        )
    }
}